import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { patchObject } from '../../../shared/util/object-util';
import { BaryModalEvent } from '../../../../models/bary-modal-event';
import { BaryModalForm } from '../../../../models/bary-modal-form';
import { CarouselItem } from '../../../../models/carousel-item.model';
import { TranslateService } from '@ngx-translate/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { BaryFormFactoryService } from '../../../../services/bary-form-factory.service';
import { CarouselItemControls } from '../../../../models/forms/builder/CarouselItemFormBuilder';

@Component({
  selector: 'jhi-bary-modal-add-card-to-carousel',
  templateUrl: './bary-modal-add-card-to-carousel.component.html',
  styleUrls: ['./bary-modal-add-card-to-carousel.component.scss'],
})
export class BaryModalAddCardToCarouselComponent extends BaryModalForm implements OnInit {
  override model: CarouselItem = new CarouselItem();
  controls: CarouselItemControls;
  isUpdate: boolean = false;

  constructor(private fb: FormBuilder, public bff: BaryFormFactoryService, public translateService: TranslateService, public modalRef: MDBModalRef) {
    super();
    this.controls = this.bff.makeCarouselItemControls(this.model);
  }

  ngOnInit(): void {
    this.controls = this.bff.makeCarouselItemControls(this.model);
    this.modalForm = this.fb.group(this.controls, { validators: [] });
  }

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  override handleSubmit(): void {
    if (this.modalForm.invalid) {
      this.modalForm.markAllAsTouched();
      this.focusOnFirstError();
    } else {
      patchObject(this.model, this.modalForm.value);
      this.action.next(new BaryModalEvent({ submit: true, value: this.model }));
      this.modalRef.hide();
    }
  }

  setButtonLabel(): string {
    return this.translateService.instant(this.isUpdate ? 'modals.addCardToCarousel.update.buttons.submit' : 'modals.addCardToCarousel.buttons.submit') as string;
  }
}
